<!--
    描述：
    时间：2020-06-01
    Created by 张卫华
-->
<template>
    <div class="h100 main-page">
        <div class="w-table-layout">
            <div class="w-table-content" ref="tableContent">
                <el-table ref="elTable"
                     v-loading="tableObj.loading"
                     :data="tableObj.tableData"
                     :border="true"
                     :height="tableObj.tableH"
                     highlight-current-row
                     :summary-method="getSummaries"
                     show-summary
                     :header-cell-style="headerCellStyle"
                >
                    <el-table-column type="index" label="序号" width="60"></el-table-column>
                    <el-table-column prop="code" label="清单编码" header-align="center" align="center" show-overflow-tooltip min-width="150"></el-table-column>
                    <el-table-column
                        v-if="compareArr1.length > 0"
                        prop="type1"
                        header-align="center" align="center">
                        <template slot="header" slot-scope="scope">
                            <el-select v-model="priceType1">
                                <el-option v-for="(item, index) in priceTypeList"
                                           :key="'价格类别' + index"
                                           :label="item.name"
                                           :value="item.value"></el-option>
                            </el-select>
                        </template>
                        <el-table-column :prop="`str1.projectFeatures`" v-if="compareArr1.includes('projectFeatures')"
                            label="清单特征" header-align="center" align="center" width="250" show-overflow-tooltip></el-table-column>
                        <el-table-column :prop="`str1.unit`" v-if="compareArr1.includes('unit')"
                            label="计量单位" header-align="center" align="center" width="80" show-overflow-tooltip></el-table-column>
                        <el-table-column :prop="`str1.quantity`" v-if="compareArr1.includes('quantity')"
                            label="工程量" header-align="center" align="center" width="100" sortable show-overflow-tooltip>
                            <template slot-scope="scope">{{ parseFloat(scope.row.str1.quantity).toFiexd(2) }}</template>
                        </el-table-column>
                        <el-table-column :prop="`str1.rateCost`" v-if="compareArr1.includes('rateCost')"
                            label="单价" header-align="center" align="center" width="100" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column :prop="`str1.addup`" v-if="compareArr1.includes('addup')"
                            label="合价" header-align="center" align="center" width="120" sortable show-overflow-tooltip></el-table-column>
                    </el-table-column>
                    <el-table-column
                        prop="type2"
                        v-if="compareArr2.length > 0"
                        header-align="center" align="center">
                        <template slot="header" slot-scope="scope">
                            <el-select v-model="priceType2">
                                <el-option v-for="(item, index) in priceTypeList"
                                           :key="'价格类别' + index"
                                           :label="item.name"
                                           :value="item.value"></el-option>
                            </el-select>
                        </template>
                        <el-table-column :prop="`str2.projectFeatures`" v-if="compareArr2.includes('projectFeatures')" label="清单特征" header-align="center" align="center" width="250" show-overflow-tooltip></el-table-column>
                        <el-table-column :prop="`str2.unit`" v-if="compareArr2.includes('unit')" label="计量单位" header-align="center" align="center" width="80" show-overflow-tooltip></el-table-column>
                        <el-table-column :prop="`str2.quantity`" v-if="compareArr2.includes('quantity')" label="工程量" header-align="center" align="center" width="100" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column :prop="`str2.rateCost`" v-if="compareArr2.includes('rateCost')" label="单价" header-align="center" align="center" width="100" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column :prop="`str2.addup`" v-if="compareArr2.includes('addup')" label="合价" header-align="center" align="center" width="120" sortable show-overflow-tooltip></el-table-column>
                    </el-table-column>

                    <el-table-column prop="amount" v-if="amountArr.length > 0" label="增减量" header-align="center" align="center" width="320">
                        <el-table-column label="工程量"
                            prop="decrement.decrementQuality"
                            v-if="amountArr.includes('quantity')"
                            header-align="center"
                            align="center"
                            :sort-by="amountSort1"
                            width="100"
                            sortable></el-table-column>
                        <el-table-column label="单价"
                            prop="decrement.decrementRateCost"
                            v-if="amountArr.includes('rateCost')"
                            sortable
                            :sort-by="amountSort2"
                            header-align="center"
                            align="right"
                            width="100"></el-table-column>
                        <el-table-column label="合价"
                            prop="decrement.decrementAddup"
                            v-if="amountArr.includes('addup')"
                            sortable
                            :sort-by="amountSort3"
                            header-align="center"
                            align="right"
                            show-overflow-tooltip
                            width="120"></el-table-column>
                    </el-table-column>
                    <el-table-column label="增减幅度"
                        prop="amountRate"
                        v-if="rateArr.length > 0"
                        header-align="center"
                        align="center"
                        width="320">
                        <el-table-column label="工程量"
                            prop="range.rangeQuality"
                            v-if="amountArr.includes('quantity')"
                            sortable
                            :sort-by="rateSort1"
                            header-align="center"
                            align="right"
                            width="100"></el-table-column>
                        <el-table-column label="单价"
                            prop="range.rangePrice"
                            v-if="amountArr.includes('rateCost')"
                            sortable
                            :sort-by="rateSort2"
                            align="center"
                            header-align="center"
                            width="100"></el-table-column>
                        <el-table-column label="合价"
                            prop="range.rangeSumPrice"
                            v-if="amountArr.includes('addup')"
                            sortable
                            :sort-by="rateSort3"
                            header-align="center"
                            align="right"
                            show-overflow-tooltip
                            width="120"></el-table-column>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import analysisJsonData from '@/api/modules/analysisDetail.json'
const jsonData = analysisJsonData
export default {
    components: {},
    props : {},
    data() {
        return {
            loading : false,
            tableObj: {
                loading: false,
                tableH: 400,
                fixedData: [], // 固定的原始数据
                tableData: [],
                currentPage: 1,
                pageSize: 10,
            },

            priceTypeList: [],
            priceType1: '1005003',
            priceType2: '1005002',

            curColumn: '', // 当前点击的列 property
            // 对比列 列过滤
            compareArr1: [
                'projectFeatures',
                'unit',
                'quantity',
                'rateCost',
                'addup'
            ],
            compareArr2: [
                'projectFeatures',
                'unit',
                'quantity',
                'rateCost',
                'addup'
            ],
            // 增减量列过滤
            amountArr: ['quantity', 'rateCost', 'addup'],
            // 增减幅度列过滤
            rateArr: ['quantity', 'rateCost', 'addup'],
            // 列筛选
            filterObj: {
                // 工程量
                quantity: {
                    amount: 100,
                    rate: 5
                },
                // 单价
                rateCost: {
                    amount: 100,
                    rate: 3
                },
                // 合价
                addup: {
                    amount: 10000,
                    rate: 6
                }
            }
        }
    },
    // 进入缓存页面触发
    activated() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.tableObj.tableH = this.$refs.tableContent.offsetHeight
            }, 100)
        })
    },
    watch: {
        clientSize(val) {
            setTimeout(() => {
                this.tableObj.tableH = this.$refs.tableContent.offsetHeight
            }, 100)
        }
    },
    computed: {
        ...mapState('app', { clientSize: state => state.clientSize }),
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.tableObj.tableH = this.$refs.tableContent.offsetHeight;
            }, 100)
        })
    },
    created() {
        //获取select list
        this.getPeriods()
    },
    methods: {
        // 初始获得数据
        getTableData(params) {
            this.tableData = []
            /*
            if (params.busProContractTreeId !== '') {
                this.loading = true
                getDetailData(params).then(res => {
                    this.loading = false
                    if (res.code === '0') {
                        this.tableObj.fixedData = res.data.list
                        this.tableObj.tableData = res.data.list
                    }
                })
            }
            */

            if (jsonData.code === '0') {
                this.tableObj.fixedData = jsonData.data.list
                this.tableObj.tableData = jsonData.data.list
            }
        },
        getPeriods(){
            this.priceTypeList = []
            /*
            getSelectedList({ id: this.curProjectId })
                .then(res => {
                    this.priceTypeList = res.data
                })
                .catch(err => {})
            */

            let item = {"name":"控制价","value":"1005002"}
            this.priceTypeList.push(item)
            item = {"name":"中标价","value":"1005003"}
            this.priceTypeList.push(item)
            item = {"name":"报审价","value":"1005004"}
            this.priceTypeList.push(item)
            item = {"name":"初审价","value":"1005005"}
            this.priceTypeList.push(item)
            item = {"name":"审定价","value":"1005006"}
            this.priceTypeList.push(item)
            item = {"name":"第1期申报进度款","value":"10"}
            this.priceTypeList.push(item)
            item = {"name":"第3期申报进度款","value":"30"}
            this.priceTypeList.push(item)
            item = {"name":"第4期申报进度款","value":"40"}
            this.priceTypeList.push(item)
            item = {"name":"第1期审核进度款","value":"11"}
            this.priceTypeList.push(item)
            item = {"name":"第2期审核进度款","value":"21"}
            this.priceTypeList.push(item)
            item = {"name":"第4期审核进度款","value":"41"}
            this.priceTypeList.push(item)
        },
        // 表尾合计行
        getSummaries(param) {
            this.$nextTick(() => {
                this.$refs.elTable.doLayout()
            })
            const { columns, data } = param
            const sums = []
            let sum2 = 0,
                sum1 = 0

            columns.forEach((column, index) => {
                sums[index] = 'N/A'

                if (index === 0) {
                    sums[index] = '合计'
                    return
                }

                // 第一个 合价
                if (column.property === 'str1.addup') {
                    let values = data.map(x => parseFloat(x.str1.addup))

                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr)
                            if (!isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0)
                        sum1 = sums[index]
                        sums[index] = sums[index].toFixed(2) + ' 元'
                    }
                }

                // 第二个合价
                if (column.property === 'str2.addup') {
                    let values = data.map(x => parseFloat(x.str2.addup))

                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr)
                            if (!isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0)
                        sum2 = sums[index]
                        sums[index] = sums[index].toFixed(2) + ' 元'
                    }
                }

                // 增减量 合价
                if (column.property === 'decrement.decrementAddup') {
                    //console.log("======> sum2 = " + sum2)
                    sums[index] = sum2.sub(sum1).toFixed(2) + ' 元'
                }

                // 增减幅度 合价
                if (column.property === 'range.rangeSumPrice') {
                    sums[index] =
                        sum1 !== 0
                            ? (sum2 / sum1 - 1).mul(100).toFixed(2) + ' %'
                            : 'N/A'
                }
            })
            return sums
        },

        // 增减量的自定义排序 --- 工程量
        amountSort1(row, index) {
            if (row) {
                return parseFloat(row.decrement.decrementQuality)
            }
        },
        amountSort2(row, index) {
            if (row) {
                return parseFloat(row.decrement.decrementRateCost)
            }
        },
        amountSort3(row, index) {
            if (row) {
                return parseFloat(row.decrement.decrementAddup)
            }
        },
        // 增减幅度自定义排序 --- 工程量
        rateSort1(row, index) {
            if (row) {
                return parseFloat(row.range.rangeQuality)
            }
        },
        // --- 单价
        rateSort2(row, index) {
            if (row) {
                return parseFloat(row.range.rangePrice)
            }
        },
        // --- 合价
        rateSort3(row, index) {
            if (row) {
                return parseFloat(row.range.rangeSumPrice)
            }
        },

        // 获取当前选择的对比列 名称
        getColumnName() {
            let params = {
                column1: '',
                column2: ''
            }

            if (this.priceTypeList.length > 0) {
                let _item1 = this.priceTypeList.find(
                    x => x.value === this.priceType1
                )
                let _item2 = this.priceTypeList.find(
                    x => x.value === this.priceType2
                )
                params.column1 = _item1 ? _item1.name : ''
                params.column2 = _item2 ? _item2.name : ''
            }
            return params
        },
        // 表头列样式
        headerCellStyle({ row, column, rowIndex, columnIndex }) {
            if (column.children && !column.label) {
                if (columnIndex === 2) {
                    return 'background : #9eefd1 !important; border-bottom : 1px solid #c7c7c7 !important; border-right : 1px solid #c7c7c7 !important;'
                } else {
                    return 'background : #f5f5ad !important; border-bottom : 1px solid #c7c7c7 !important; border-right : 1px solid #c7c7c7 !important;'
                }
            }else if(column.children && column.label){
                if(columnIndex === 4){
                    return 'border-bottom : 1px solid #c7c7c7 !important; border-right : 1px solid #c7c7c7 !important;'
                }else if(columnIndex === 5){
                    return 'border-bottom : 1px solid #c7c7c7 !important;'
                }
            }
        },
    }
}
</script>

<style lang="less" scoped>
.el-select .el-input__inner{
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 29px !important;;
    line-height: 29px !important;;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
</style>